<template>
    <div class="modal-overlay" @close="$emit('close')">
        <div class="modal" ref="myBtn" @close="$emit('close')">
            <div class="mb-4 allDiv">
                <label class="mb-2 cssMessage">Please Enter Template Name</label>
                <input type="text" v-model="templateName" @input="checkValidation" maxlength="20" class="form-control custom-input" />
                <span class="text-danger" v-if="errorTemplateName">Please Enter Template Name</span>
                <span class="text-danger" v-if="errorBack">The template name has already been taken. </span>
            </div>
            <div class="d-flex gap-3">
                <button class="confirm-btn" @click="confirmHandler">{{confirmBtn}}</button>
                <button class="cancle-btn" @click="cancleHandler">{{cancleBtn}}</button>
            </div>

        </div>
    </div>
    <AlartModal v-if="this.showModalTemplate" message="Temaplte Copied Successfully" imagePath="okImage.svg"
                @close-modal="this.showModalTemplate = false"/>
</template>

<script>
    // import {onMounted} from "vue";
    // import mitt from 'mitt';
    // const emitter = mitt();
    import repository from "../../api-services/repository";
    import AlartModal from "./AlartModal";

    export default {
        name:'copy-template-component',
        components:{AlartModal},
        props: ['cancleBtn', 'confirmBtn', 'message' , 'template_id' , 'templateName'],
        data(){
            return {
                state: false,
                showModalTemplate:false,
                errorTemplateName:false,
                errorBack:false
            }
        },
        methods:{
            checkValidation(){
                this.errorBack = false;
                this.errorTemplateName = false;
            },
            async confirmHandler(){
                if(this.templateName === null || this.templateName === ''){
                    this.errorBack = false;
                    this.errorTemplateName = true;
                }else{
                    this.errorTemplateName = false;

                    try{
                        await repository.getTemplateData(this.template_id , {templateName:this.templateName});
                        this.showModalTemplate = true;

                        setTimeout(() => {
                            this.$emit('close-modal', true);
                        } , 1000);

                        setTimeout(async () => {
                            window.location.reload();
                        }, 1000);

                    }catch (e) {
                        this.errorBack = true;
                        this.errorTemplateName = false;
                    }

                }
            },
            cancleHandler(){
                this.$emit('close-modal', false)
            }
        }

    }
</script>

<style scoped>
    .cssMessage{
        color: var(--text-color-in-Confirm-immed);
    }

    .allDiv{
        width:41%;
    }
    .custom-input{
        background-color: transparent;
        color: var(--main-color);
        padding: 10px;
        width: 100%;
    }
    .custom-input:focus{
        background-color: transparent;
        color: var(--main-color);
    }

    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000;
        z-index: 100;
    }

    .modal {
        text-align: center;
        display: flex !important;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        position: unset !important;
        background-color: var(--background-color-input-create);
        height: 220px;
        border-radius: 20px;
        margin: auto;
        width: 40%;
    }


    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        font-size: 22px;
        margin: 30px 0;
        color: #FFF;
    }

    button {
        width: 150px;
        height: 50px;
        color: white;
        font-size: 18px;
        border-radius: 8px;
        font-weight: 600;
    }

    .confirm-btn{
        background-color: var(--btn-bg-color);
        border: 1px solid transparent;
    }
    .cancle-btn{
        background-color: transparent;
        color: var(--text-color-in-confirmation-modal);
        border: 1px solid var(--text-border-color-in-confirmation-modal);
    }
</style>